import { TypeContact } from '../types/enums';
import { validateEmail } from './validateEmail';
import { validatePhone } from './validatePhone';
import { unMask } from './removeMask';

/**
 * Normaliza o type vindo da API/form (number | string).
 * WHATSAPP = 0, EMAIL = 1 — alinhado ao ExternalContactType do backend.
 */
export const normalizeTypeContact = (type: unknown): TypeContact => {
  const numericType = Number(type);
  if (numericType === TypeContact.EMAIL) {
    return TypeContact.EMAIL;
  }
  return TypeContact.WHATSAPP;
};

/**
 * Infere o tipo a partir do valor (e-mail ou telefone com 11 dígitos).
 */
export const inferTypeFromContactValue = (value: string): TypeContact | null => {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) return null;

  const digitsOnly = unMask(trimmed);
  const candidateEmail = trimmed.includes('@') ? trimmed : digitsOnly;

  if (validateEmail(candidateEmail)) return TypeContact.EMAIL;
  if (validatePhone(trimmed) || validatePhone(digitsOnly)) return TypeContact.WHATSAPP;

  return null;
};

/**
 * Resolve o tipo correto (corrige legado em que Type=0 era EMAIL no backend antigo).
 */
export const resolveExternalContactType = (type: unknown, value: string): TypeContact => {
  const normalizedType = normalizeTypeContact(type);
  const inferredType = inferTypeFromContactValue(value);
  return inferredType ?? normalizedType;
};

export const isExternalContactTypeConsistent = (type: TypeContact, value: string): boolean => {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) return false;

  if (type === TypeContact.EMAIL) {
    return validateEmail(trimmed);
  }

  return validatePhone(trimmed) || validatePhone(unMask(trimmed));
};

/**
 * Remove letras e caracteres de máscara de valores de telefone/WhatsApp (dados legados).
 */
export const sanitizeContactValueForType = (type: TypeContact, value: string): string => {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) return '';

  if (type === TypeContact.WHATSAPP) {
    return unMask(trimmed);
  }

  return trimmed;
};
